import * as React from 'react';
import * as classnames from 'classnames/bind';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';

const styles = require('./DialogError.less');
const cx = classnames.bind(styles);

export class DialogErrorProps
{
    className?:string;
    message:string;
}

export class DialogError extends React.Component<DialogErrorProps, any>
{
    render()
    {
        const {className, message} = this.props;

        if (!message) return null;

        return (
            <Row
                className={cx('dialogError', className)}
                >
                <Row className={cx('dialogErrorMessage')}>
                    {message}
                </Row>
            </Row>
        );
    }
}
